import axios from 'axios';
import Cookies from 'js-cookie';
const API_URL = `${process.env.REACT_APP_API_URL}/api/clientportal/v1/auth`;



  const setToken=(token)=>{
    Cookies.set('admone_cp', JSON.stringify(token), { 
      expires: 1 / 12, 
      // expires: 15 / 1440,
      path: '/',
      // domain: process.env.REACT_APP_COOKIE_URL || undefined,
      // secure: secureFlag,  // Set secure flag
    
    }); 
  }

const setUserDetails = (res) => {
  
    const id = res.data.user.user.id;
    const name = res.data.user.user.name;
    const email = res.data.user.user.email;
    const phone = res.data.user.user.phone;


    // const client = res.data.user.user.clients;
    const acesssToken = res.data.user.token.access.token;
    const refreshToken = res.data.user.token.refresh.token;
    const middleName = res.data.user.user.surname;
     localStorage.setItem("userName", name);
    localStorage.setItem("middleName", middleName);
    localStorage.setItem("email", email);
    localStorage.setItem("phone", phone);


    localStorage.setItem("userId", id);
    // localStorage.setItem("client", client);
    //  localStorage.setItem("token", acesssToken);
    // localStorage.setItem("refreshToken",refreshToken);
 
  // setAccessToken(acesssToken);
  // setRefreshToken(refreshToken);

  };
  
  const login = async (data ) => {
   const res = await axios.post(API_URL + "/login",data)

  //  console.log("res",res)
  const tokens = {
    accessToken: res.data.user.token.access.token,
    refreshToken:  res.data.user.token.refresh.token
  };
      setToken(tokens)
    setUserDetails(res);
  
    return res;

} 


// Forget the session in this browser only.
const clearLocalSession = () => {
  localStorage.removeItem("userName");
  localStorage.removeItem("middleName");

  localStorage.removeItem("userId");
  localStorage.removeItem("client");
  // localStorage.removeItem("token");

  Cookies.remove('admone_cp', { path: '/' });
}

// Ends the session on the server too, so the token stops working even if a
// copy of it survives somewhere. The browser side is cleared whatever the API
// says: a failed call must not leave someone stuck signed in.
const logout = async ( ) => {
  try {
    const { accessToken } = JSON.parse(Cookies.get('admone_cp') || '{}');
    if (accessToken) {
      await axios.post(API_URL + "/logout", {}, {
        headers: { Authorization: `Bearer ${accessToken}` },
      });
    }
  } catch (error) {
    console.error('Logout call failed:', error.message);
  }
  clearLocalSession();
} 



 const RefreshToken = async (data ) => {
    const res = await axios.post(API_URL + "/refreshToken",data)
    

    const tokens = {
      accessToken: res.data.token.access.token,
      refreshToken:  res.data.token.refresh.token
    };
        setToken(tokens)
     
     return res;
 
 }


const LoginAuth={
    
    login,RefreshToken,logout,clearLocalSession

}

export default LoginAuth